import { render, staticRenderFns } from "./LmProcessNewOrEdit.vue?vue&type=template&id=839047f0&scoped=true&"
import script from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessNewOrEdit.vue?vue&type=style&index=0&id=839047f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839047f0",
  null
  
)

export default component.exports